import {GlobalVariables} from "../GlobalVariables";

export default class LayoutOffset {
    constructor() {
        this.layouts = document.querySelectorAll("[data-offset]");
        if (this.layouts.length > 0) {
            this.initLayoutOffsetVariables();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    initLayoutOffsetVariables() {
        this.layouts.forEach((layout) => {
            const rect = layout.getBoundingClientRect();
            const styles = window.getComputedStyle(layout);

            const paddingLeft = parseFloat(styles.paddingLeft);
            const paddingRight = parseFloat(styles.paddingRight);
            const borderLeft = parseFloat(styles.borderLeftWidth);
            const borderRight = parseFloat(styles.borderRightWidth);

            const paddingBoxLeft = rect.left + borderLeft + paddingLeft;
            const paddingBoxRight = window.innerWidth - (rect.right - borderRight - paddingBoxLeft);

            layout.style.setProperty("--offset-left", `${paddingBoxLeft}px`);
            layout.style.setProperty("--offset-right", `${paddingBoxRight}px`);

        });
    }

    resize() {
        this.initLayoutOffsetVariables();
    }
}